import { ClipboardModule } from '@angular/cdk/clipboard';
import { AsyncPipe } from '@angular/common';
import { DatePipe, NgStyle, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FwFormHeadingModule,
  FwIconModule,
  FwProgressModule,
  FwSelectMenuModule,
  FwTooltipModule,
  FwWrappedInputComponent,
} from '@flywheel-io/vision';

import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { OperationPopoverComponent } from './components/operation-popover/operation-popover.component';
import { OperationStatusComponent } from './components/operation-status/operation-status.component';
import { OperationStorageSelect } from './components/operation-storage-select/operation-storage-select.component';
import { OperationsDetailsTable } from './components/operations-details-table/operations-details-table.component';
import { StatusChipComponent } from './components/status-chip/status-chip.component';

@NgModule({
  imports: [
    AsyncPipe,
    DatePipe,
    ClipboardModule,
    FwFormHeadingModule,
    FwIconModule,
    FwProgressModule,
    FwSelectMenuModule,
    FwTooltipModule,
    NgStyle,
    PipesModule,
    SharedModule,
    TitleCasePipe,
    FwWrappedInputComponent,
  ],
  declarations: [
    OperationPopoverComponent,
    OperationStatusComponent,
    OperationStorageSelect,
    OperationsDetailsTable,
    StatusChipComponent,
  ],
  exports: [
    OperationPopoverComponent,
    OperationStatusComponent,
    OperationStorageSelect,
    OperationsDetailsTable,
    StatusChipComponent,
  ],
})
export class XferModule {}
